export default "__VITE_ASSET__Cj7B3dR8__"